import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';

import { TYPES } from '../../data/config/constants';
import { showMessage, log } from '../../data/config/utils';
import { IMG_ERROR } from '../../data/assets/img';

import ShowMessage from '../showmessage';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    log('error', error)
    log('errorInfo', errorInfo)
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo)
      Sentry.captureException(error)
    })
    this.setState({ hasError: true }, () => {
      showMessage('error', 'Errorboundary: some error occured.')
      if (this.props.onErrorCallback)
        this.props.onErrorCallback()
    })
  }

  render() {
    const { type, error_title, error_message, show_button, handleButtonClick, children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      if (type === TYPES.ERROR) {
        return (
          <ShowMessage img_src={IMG_ERROR} title={error_title} message={error_message} height={140} width={140} show_button={show_button} handleButtonClick={handleButtonClick} />
        );
      } else {
        return null;
      }
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  type: PropTypes.string,
  error_title: PropTypes.string,
  error_message: PropTypes.string,
  onErrorCallback: PropTypes.func,
  show_button: PropTypes.bool,
  handleButtonClick: PropTypes.func,
};

ErrorBoundary.defaultProps = {
  show_button: false,
  error_title: "Error",
  error_message: "something went worng.",
};



// WEBPACK FOOTER //
// ./src/components/errorboundary/index.js